export const scrollTo = ({ top, left, behavior = 'smooth' }: ScrollToOptions) => {
  if (document.documentElement) {
    document.documentElement.scrollTo({ top, left, behavior });
  }
};
